import { render, staticRenderFns } from "./videoSourceDialog.vue?vue&type=template&id=06d2e3d2&scoped=true&"
import script from "./videoSourceDialog.vue?vue&type=script&lang=js&"
export * from "./videoSourceDialog.vue?vue&type=script&lang=js&"
import style1 from "./videoSourceDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d2e3d2",
  null
  
)

export default component.exports